import React, { useState, useEffect } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { useTranslation } from 'react-i18next';

const BasicDatatable = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [securityCk, setUser] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [depositInput, setDepositInput] = useState({
    email_code: '',
    error_list: [],
  });

  useEffect(() => {
    const auth_token = localStorage.getItem('auth_token');
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      currency: selectedCurrency,
    };
    if (auth_token) {
      axios.post('/security-home', data)
        .then(response => {
          setUser(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }, []);

  const handleInput = (e) => {
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  };

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      email_code: depositInput.email_code,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
    };
    if (auth_token) {
      axios.post(`/email-account-verify-sub`, data).then(res => {
        if (res.data.status === 'success') {
          setShowModal(false);
          window.location.reload();
          swal("Success", res.data.message, "success");
          setDepositInput({ email_code: '', error_list: [] });
        } else if (res.data.status === 'fail') {
          swal("Warning", res.data.message, "warning");
        } else {
          setDepositInput({ ...depositInput, error_list: res.data.validation_error });
        }
      });
    }
  };

  const handleLinkClick = () => {
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      root_url: "https://account.segma.app/",
    };
    if (auth_token && !loading) {
      setLoading(true);
      axios.post('/email-account-verify', data)
        .then(res => {
          setLoading(false);
          if (res.data.status === 'success') {
            setShowModal(res.data.message);
          } else {
            swal("Warning", res.data.message, "warning");
          }
        })
        .catch(error => {
          setLoading(false);
          console.log(error);
        });
    }
  };

  let id, identity_st, mail_status;
  if (securityCk && securityCk.data) {
    id = securityCk.data.id;
    identity_st = securityCk.data.identity_status;
    mail_status = securityCk.data.mail_status;
  }

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="container-fluid py-4">
      <div className="row g-4">

        {mail_status === 0 && (
          <div className="col-12">
            <Alert variant="warning" className="d-flex justify-content-between align-items-center">
              <span>{t('pro_security_email_resend')}</span>
              <Button variant="success" size="sm" onClick={handleLinkClick}>
                {loading ? 'Sending...' : 'Verify Now'}
              </Button>
            </Alert>
          </div>
        )}

        <div className="col-md-4">
          <Link to="/change-password" className="text-decoration-none">
            <div className="card text-center shadow-sm border-0 h-100 p-3" style={{ background: "#f5f5f5", borderRadius: "12px" }}>
              <div className="mb-3">
                <i className="bi bi-shield-lock" style={{ fontSize: "2rem", color: "#4caf50" }}></i>
              </div>
              <h5 className="text-dark">{t('pro_security_ch_ps')}</h5>
              <p className="text-muted">{t('pro_security_click_ch_ps')}</p>
            </div>
          </Link>
        </div>

        <div className="col-md-4">
          <div className="card text-center shadow-sm border-0 h-100 p-3" style={{ background: "#e9f7ef", borderRadius: "12px" }}>
            <div className="mb-3">
              {mail_status === 0 ? (
                <i className="bi bi-x-circle-fill" style={{ fontSize: "2rem", color: "#dc3545" }}></i>
              ) : (
                <i className="bi bi-check-circle-fill" style={{ fontSize: "2rem", color: "#28a745" }}></i>
              )}
            </div>
            <h5 className="text-dark">{t('pro_security_to_gac_auth')}</h5>
            <p className="text-muted">{t('pro_security_to_gac_text')}</p>
          </div>
        </div>

        <div className="col-md-4">
          {identity_st === 0 || identity_st === 3 ? (
            <Link to="/identity-verification" className="text-decoration-none">
              <div className="card text-center shadow-sm border-0 h-100 p-3" style={{ background: "#fff3cd", borderRadius: "12px" }}>
                <div className="mb-3">
                  <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: "2rem", color: "#ffc107" }}></i>
                </div>
                <h5 className="text-dark">{t('pro_security_nid')}</h5>
                <p className="text-muted">
                  {identity_st === 0 ? "Unverified - Verify Now" : "Resubmit Required"}
                </p>
              </div>
            </Link>
          ) : (
            <div className="card text-center shadow-sm border-0 h-100 p-3" style={{ background: "#d4edda", borderRadius: "12px" }}>
              <div className="mb-3">
                <i className="bi bi-patch-check-fill" style={{ fontSize: "2rem", color: "#28a745" }}></i>
              </div>
              <h5 className="text-dark">{t('pro_security_nid')}</h5>
              <p className="text-muted">
                {identity_st === 1 ? "Verified" : "Submitted - Under Review"}
              </p>
            </div>
          )}
        </div>

      </div>

      {/* Modal for Email Verification */}
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={depositSubmit}>
            <div className="form-group mb-3">
              <label htmlFor="email_code">Enter Email Code</label>
              <input
                type="text"
                className="form-control"
                id="email_code"
                name="email_code"
                value={depositInput.email_code}
                onChange={handleInput}
                required
              />
              {depositInput.error_list.email_code && (
                <small className="text-danger">{depositInput.error_list.email_code}</small>
              )}
            </div>
            <Button type="submit" variant="primary" className="w-100">
              Submit
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BasicDatatable;
